export default __webpack_public_path__ + "static/media/RelayImg.4964b765.jpg";